import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HomepageBanner } from '@core/models/homepage-banner.model';
import { Observable } from 'rxjs';
import { API_LIST } from '@core/services/web-api/api-list';

@Injectable({ providedIn: 'root' })
export class HomepageBannerService {
  constructor(private http: HttpClient) {}

  getActiveBanner(): Observable<HomepageBanner> {
    return this.http.get<HomepageBanner>(API_LIST.getActiveHomepageBanner());
  }
}
